import cfHoy from '@clickfunnels2/cfhoy.js'
import { Cookies } from '@clickfunnels2/cfhoy.js'

function cfhoyVisitorData() {
  return {
    firstName: Cookies.get('contact_first_name'),
    lastName: Cookies.get('contact_last_name'),
    emailAddress: Cookies.get('contact_email_address'),
    phoneNumber: Cookies.get('contact_phone_number'),
    postalCode: Cookies.get('contact_postal_code'),
    country: Cookies.get('contact_country'),
    uuid: Cookies.get('cfhoy_visitor'),
  }
}

function getLeadEventID() {
  return Cookies.get('cfhoy_lead_event_id')
}

function removeLeadEventID() {
  Cookies.set('cfhoy_lead_event_id', '', -1)
  return true
}

function getPurchaseEventID() {
  return Cookies.get('cfhoy_purchase_event_id')
}

function removePurchaseEventID() {
  Cookies.set('cfhoy_purchase_event_id', '', -1)
  return true
}

function getRenderedPage() {
  return document.querySelector('meta[name="rendered-page-url"]')?.getAttribute('content')
}

const getDomain = () => {
  // This is a naive approach meant to hold us over until we can use the official solution
  // Use window.cookie_domain once https://github.com/clickfunnels2/admin/pull/23993 is merged
  const parts = window.location.hostname.split('.')
  const countToKeep = parts.length > 3 ? 3 : 2
  return parts.slice(parts.length - countToKeep).join('.')
}
let livePage = isLivePage(window.location.search)
let trackingDisabled = window.disableTracking

const renderedPage = getRenderedPage()
// we need to configure ahoy before DOMContentLoaded event
// so it can track the visit correctly
// We need to configure cfHoy even when tracking is disabled, so cfHoy knows not to startOnReady (which is the default behavior)
cfHoy.configure({
  urlPrefix: '/_tracking',
  visitsUrl: '/visits',
  eventsUrl: '/events',
  platform: 'Web',
  useBeacon: true,
  startOnReady: false,
  trackVisits: true,
  cookies: true,
  withCredentials: false,
  visitDuration: 4 * 60, // 4 hours
  visitorDuration: 2 * 365 * 24 * 60, // 2 years
  page: renderedPage,
  trackPageViewWithVisit: true,
  trackPageViewWithVisitAdditionalProps: () => ({
    cfhoy_visitor: Cookies.get('cfhoy_visitor') || '',
    request_type: 'visit',
  }),
  extendedInstrumentation: true,
})

// ahoy
if (!trackingDisabled && livePage) {
  window.addEventListener('load', () => {
    cfHoy.start()
  })

  document.addEventListener('cfhoy:tracked', function (event) {
    window.dataLayer = window.dataLayer || []
    if (event.detail.name == '$view') {
      const visitorData = cfhoyVisitorData()
      dataLayer.push({
        event: 'cfPageView',
        contactFirstName: visitorData.firstName,
        contactLastName: visitorData.lastName,
        contactEmailAddress: visitorData.emailAddress,
        contactPhoneNumber: visitorData.phoneNumber,
        contactPostalCode: visitorData.postalCode,
        contactCountry: visitorData.country,
        contactExternalID: visitorData.uuid,
        visitEventID: event.detail.id,
      })
    }
  })
  document.addEventListener('DOMContentLoaded', function (event) {
    const additionalProps = {
      cfhoy_visitor: Cookies.get('cfhoy_visitor') || '',
      request_type: 'trackView',
    }
    cfHoy.trackView(additionalProps)

    $(document).on('click', '[event-tracking="enable"]', function () {
      const data = {
        url: window.location.href,
        page: renderedPage || window.location.pathname,
        title: document.title,
      }

      cfHoy.track('$button_click', data)
    })
  })
}

function isLivePage(queryString) {
  const urlParams = new URLSearchParams(queryString)
  return urlParams.get('preview') !== 'true'
}

document.addEventListener('DOMContentLoaded', function (event) {
  window.dataLayer = window.dataLayer || []

  const visitorData = cfhoyVisitorData()
  const leadEventID = getLeadEventID()
  const purchaseEventID = getPurchaseEventID()

  if (leadEventID) {
    dataLayer.push({
      event: 'cfLead',
      contactFirstName: visitorData.firstName,
      contactLastName: visitorData.lastName,
      contactEmailAddress: visitorData.emailAddress,
      contactPhoneNumber: visitorData.phoneNumber,
      contactPostalCode: visitorData.postalCode,
      contactCountry: visitorData.country,
      contactExternalID: visitorData.uuid,
      leadEventID: leadEventID,
    })
    removeLeadEventID()
  }

  if (purchaseEventID) {
    dataLayer.push({
      event: 'cfPurchase',
      contactFirstName: visitorData.firstName,
      contactLastName: visitorData.lastName,
      contactEmailAddress: visitorData.emailAddress,
      contactPhoneNumber: visitorData.phoneNumber,
      contactPostalCode: visitorData.postalCode,
      contactCountry: visitorData.country,
      contactExternalID: visitorData.uuid,
      purchaseEventID: purchaseEventID,
    })
    removePurchaseEventID()
  }
})
